/*
 * @Author: liguokang
 * @Date: 2021-06-03 19:15:28
 * @LastEditors: liguokang
 * @LastEditTime: 2021-07-16 17:32:00
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */

const curriculaVariable = {
  state: {
    preventScroll: false,
    courseRsevRules: {}, //机构设置的约课条件
    assetsAccountId: undefined,
    fetchTeachTimeInfoOVS: {},
    today: null,
    classReserveData: {},
    studyTime: null,
    selectVal: null,
    techAvablTimeFrsh: false,
    couesrListShow: true,
    canNotResev: false,
    activeList: [],
    conFreshclearAll: false,
    teachRest: false,
    tipsHeight: 0,
    calendarShow: false,
    schedItemSize: 0,
    stuClasAcutInfo: {},
    childResvedTime: {},
    mineQueueNum: {},
  },
  mutations: {
    PREVENTSCROLL: (state, data) => {
      state.preventScroll = data;
    },
    SETRESVRULES: (state, data) => {
      state.courseRsevRules = data;
    },
    SETACCOUNTID: (state, data) => {
      state.assetsAccountId = data;
    },
    SETTEACHERTIME: (state, data) => {
      state.fetchTeachTimeInfoOVS = data;
    },
    SETODAY: (state, data) => {
      state.today = data;
    },
    SETCLASSRESEER: (state, data) => {
      state.classReserveData = data;
    },
    SETSTUDYTIME: (state, data) => {
      state.studyTime = data;
    },
    SELECTVAL: (state, data) => {
      state.selectVal = data;
    },
    TECHTIMEFRESH: (state, data) => {
      state.techAvablTimeFrsh = data;
    },
    SHOWCOURSELIST: (state, data) => {
      state.couesrListShow = data;
    },
    canNotResev: (state, data) => {
      state.canNotResev = data;
    },
    ACTIVELIST: (state, data) => {
      state.activeList = data;
    },
    CLEARALL: (state, data) => {
      state.conFreshclearAll = data;
    },
    TEACHREST: (state, data) => {
      state.teachRest = data;
    },
    TIPSHEIGHT: (state, data) => {
      state.tipsHeight = data;
    },
    CALENDARSHOW: (state, data) => {
      state.calendarShow = data;
    },
    SCHEDITEMSIZE: (state, data) => {
      state.schedItemSize = data;
    },
    STUCLASACUTINFO: (state, data) => {
      state.stuClasAcutInfo = data;
    },
    CHILDRESVEDTIME: (state, data) => {
      state.childResvedTime = data;
    },
    QUEUENUM: (state, data) => {
      state.mineQueueNum = data;
    },
  },
  actions: {
    setAssetsAccountId({ commit }, data) {
      commit('SETACCOUNTID', data);
    },
    setTeacherAvailableTime({ commit }, data) {
      commit('SETTEACHERTIME', data);
    },
    setPreventScroll({ commit }, data) {
      commit('PREVENTSCROLL', data);
    },
    setResvrules({ commit }, data) {
      commit('SETRESVRULES', data);
    },
    setToday({ commit }, data) {
      commit('SETODAY', data);
    },
    setClassReserveOV({ commit }, data) {
      commit('SETCLASSRESEER', data);
    },
    setStydyTime({ commit }, data) {
      commit('SETSTUDYTIME', data);
    },
    setSelectVal({ commit }, data) {
      commit('SELECTVAL', data);
    },
    setTechFrsh({ commit }, data) {
      commit('TECHTIMEFRESH', data);
    },
    setShowCourseList({ commit }, data) {
      commit('SHOWCOURSELIST', data);
    },
    setCanNotResev({ commit }, data) {
      commit('canNotResev', data);
    },
    setActiveList({ commit }, data) {
      commit('ACTIVELIST', data);
    },
    setClearAll({ commit }, data) {
      commit('CLEARALL', data);
    },
    setTeachRest({ commit }, data) {
      commit('TEACHREST', data);
    },
    setTipsHeight({ commit }, data) {
      commit('TIPSHEIGHT', data);
    },
    setCalendarShow({ commit }, data) {
      commit('CALENDARSHOW', data);
    },
    setSchedItemSize({ commit }, data) {
      commit('SCHEDITEMSIZE', data);
    },
    setStuClasAcutInfo({ commit }, data) {
      commit('STUCLASACUTINFO', data);
    },
    setChildResvedTime({ commit }, data) {
      commit('CHILDRESVEDTIME', data);
    },
    setQueueNum({ commit }, data) {
      commit('QUEUENUM', data);
    },
  },
};

export default curriculaVariable;



// WEBPACK FOOTER //
// ./src/store/modules/curriculaVariable.js